import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomFunctionService } from '../../../../../custom-function.service';
import { selectUser, State } from '@lmc-app/store';
import { User } from '@lmc-app/shared/interface/user.interface';

@Component({
	selector: 'app-nlsagencycollectionscollectorclients',
	templateUrl: './nlsagencycollectionscollectorclients.component.html',
	styleUrls: ['./nlsagencycollectionscollectorclients.component.scss'],
})
export class NlsagencycollectionscollectorclientsComponent
	implements OnInit, OnDestroy
{
	private readonly _onDestroy = new Subject<void>();

	collectorName: string;
	agencyName: string;
	clientArray: string[] = [];
	totalAmount: any;

	constructor(
		private apiService: LegacyApiService,
		private router: ActivatedRoute,
		private _routerLink: Router,
		private customfunction: CustomFunctionService,
		private store: Store<State>
	) {}

	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					// Get the creditor name the nlsagencygrouped page link
					this.router.queryParams.subscribe((params) => {
						(this.collectorName = params['collector']),
							(this.agencyName = params['agency']);
					});

					// Send the creditor name to get the agencies listed under the creditor
					this.apiService
						.getNLSagencyCollectionsCollectorClients(
							this.collectorName,
							this.agencyName
						)
						.subscribe((res) => {
							console.log(res.data);
							this.clientArray = res.data;
							this.customfunction.sortColumn(
								this.clientArray,
								'current_principal_balance',
								-1,
								1
							);
							this.totalAmount = this.customfunction.sumNumbers(
								res.data,
								'current_principal_balance'
							);
							console.log(this.totalAmount);
						});
				}
			});
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
